var _g, _g2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPersonalisation(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 99.21 99.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M20.72,92.15l-1.23-12.24-12.65-.81L81.82,4.04c2.01-2.01,5.16-2.15,7.12-.31l7.05,6.63c1.81,1.71,1.77,4.66-.09,6.53L20.72,92.15Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "19.64 93.24 1.89 97.52 5.78 80.16 73.27 12.68 87.21 25.67 19.64 93.24"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 74.93,
    y1: 24.48,
    x2: 19.82,
    y2: 79.59
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.67,
    y1: 89.58,
    x2: 10.01,
    y2: 95.56
  }), /*#__PURE__*/React.createElement("line", {
    x1: 69.21,
    y1: 17.89,
    x2: 81.88,
    y2: 29.84
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M46.08,39.83l-5.45-6.87c-7.55-9.32-15.86-18.02-24.82-25.98l-4.53-4.03c-1.75-1.55-4.19-1.69-5.71-.33l-.36.32c-1.72,1.54-1.83,4.31-.27,6.44l2.8,3.81c7.93,10.79,20.59,23.76,29.97,33.32"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "51.38 61.46 64.86 75.34 70.89 69.93 59.1 55.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1,90.05c-4.83-5.39-4.94-13.19-.23-17.41,4.71-4.22,12.44-3.27,17.28,2.13.21.24.4.48.6.73l.03-.03s4.46,3.98,4.72,15.19c.1,4.39,6.74,5.62,6.74,5.62,0,0-15.37,3.92-26.12-3.66-1.08-.7-2.1-1.56-3.02-2.58Z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 64.1,
    y1: 62.26,
    x2: 58.02,
    y2: 67.71
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84.24,84.74s1.45,6.07,9.96,10.82"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalisation);
export default __webpack_public_path__ + "static/media/Personalisation.f9eafa2b96106038d3728811f8c8b16c.svg";
export { ForwardRef as ReactComponent };